// import React from "react";

// function PrescriptionFooter({ clinicDetails, doctorData }) {
//   console.log(' data view ',clinicDetails,doctorData);
//   return (
//     <div>
//       {
//         (clinicDetails?.prescription_FooterYN === 'Y' || (clinicDetails?.prescription_FooterYN === 'C' && !doctorData.footerDetails)) ?
//           (
//             <div className="h-10 my-6">
//               <p className="px-2"><span className="font-semibold">Disclaimer</span>: This prescription has been issued via telemedicine based on the information provided by the patient. In case of any emergency or worsening symptoms, please consult a doctor in person or visit the nearest healthcare facility immediately.</p>
//             </div>
//           )
//           :
//           clinicDetails?.prescription_FooterYN === 'C' && doctorData.footerDetails ?
//             (
//               <div dangerouslySetInnerHTML={{ __html: atob(doctorData.footerDetails).replace(/className=/g, 'class=') }} />
//             )
//             :
//             clinicDetails?.prescription_FooterYN === 'N' ?
//               (
//                 <div style={{
//                   height: `${clinicDetails.prescription_Footer_Space}px`
//                 }}
//                   className="h-auto">

//                 </div>
//               ) : ''

//       }
//       <div className="w-full flex justify-end items-center p-1.5">
//         <p className="italic text-brand-textGray">Powered by Doxzon</p>
//       </div>
//     </div>
//   );
// }

// export default PrescriptionFooter;

import React from "react";

// ─── Utility Helpers (same pattern as PrescriptionHeader) ───────────────────

const isValidString = (val) =>
  val !== null &&
  val !== undefined &&
  typeof val === "string" &&
  val.trim() !== "" &&
  val.trim().toLowerCase() !== "invalid date";

const isValidValue = (val) => {
  if (val === null || val === undefined) return false;
  if (typeof val === "number") return val !== 0;
  if (typeof val === "string") return isValidString(val);
  return false;
};

const safeAtob = (encoded) => {
  try {
    return atob(encoded).replace(/className=/g, "class=");
  } catch {
    return null;
  }
};

// ─── Sub-components ──────────────────────────────────────────────────────────

const Disclaimer = () => (
  <div className="my-6">
    <p className="px-2 text-sm text-gray-700">
      <span className="font-semibold">Disclaimer</span>: This prescription has
      been issued via telemedicine based on the information provided by the
      patient. In case of any emergency or worsening symptoms, please consult a
      doctor in person or visit the nearest healthcare facility immediately.
    </p>
  </div>
);

const PoweredBy = () => (
  <div className="w-full flex justify-end items-center p-1.5">
    <p className="italic text-brand-textGray">Powered by Doxzon</p>
  </div>
);

// ─── Main Component ──────────────────────────────────────────────────────────

function PrescriptionFooter({ clinicDetails, doctorData }) {
  const footerType = clinicDetails?.prescription_FooterYN;
  const hasCustomFooter = isValidString(doctorData?.footerDetails);

  const renderFooterContent = () => {
    // Case 1 — Custom HTML footer (base64 encoded)
    if (footerType === "C" && hasCustomFooter) {
      const decoded = safeAtob(doctorData.footerDetails);
      if (!decoded) return null; // skip silently if decode fails
      return <div dangerouslySetInnerHTML={{ __html: decoded }} />;
    }

    // Case 2 — System footer ('Y') OR 'C' with no custom footer fallback
    if (footerType === "Y" || (footerType === "C" && !hasCustomFooter)) {
      return <Disclaimer />;
    }

    // Case 3 — No footer, just reserve vertical space
    if (footerType === "N") {
      const space = isValidValue(clinicDetails?.prescription_Footer_Space)
        ? clinicDetails.prescription_Footer_Space
        : 0;
      return <div style={{ height: `${space}px` }} />;
    }

    // Case 4 — Unknown / missing footerType
    return null;
  };

  return (
    <div>
      {renderFooterContent()}
      <PoweredBy />
    </div>
  );
}

export default PrescriptionFooter;
